import { useListContext } from 'framework/list';
//@ts-ignore
import InfiniteScroll from 'react-infinite-scroller';
import React from 'react';
import LoadMore from './LoadMore';
import { TimelineContextData } from '../Timeline';
import { useUiTheme } from 'framework/uiTheme';
import { SmallLoader as DefaultSmallLoader } from 'framework/ui/mui-builder';
import { Box } from '@mui/material';

const DEFAULT_LOAD_MORE_FUNCTION = () => {};

type TimelinePagingHandlerProps = {
  children?: React.ReactNode;
};

const TimelinePagingHandler = ({ children }: TimelinePagingHandlerProps) => {
  const { SmallLoader: ThemedSmallLoader } = useUiTheme();
  const SmallLoader = ThemedSmallLoader || DefaultSmallLoader;
  const loaderContainer = (
    <Box display="flex" justifyContent="center">
      <SmallLoader />
    </Box>
  );
  const {
    isEntryViewMode,
    loadNextPage = DEFAULT_LOAD_MORE_FUNCTION,
    hasMoreData = () => false,
    isLoadingPrevPage,
    isLoadingNextPage,
    scrollableContainer,
    useWindow = true,
  }: TimelineContextData = useListContext();

  const hasMore = hasMoreData();

  const getScrollParent = () => {
    if (scrollableContainer && scrollableContainer.current) {
      return scrollableContainer.current;
    }
    return null;
  };

  if (isEntryViewMode) {
    return <LoadMore>{children}</LoadMore>;
  } else {
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={loadNextPage}
        hasMore={hasMore}
        initialLoad={false}
        useWindow={useWindow}
        getScrollParent={useWindow ? undefined : getScrollParent}
        loader={loaderContainer}
      >
        {isLoadingPrevPage && loaderContainer}
        {children}
        {isLoadingNextPage && loaderContainer}
      </InfiniteScroll>
    );
  }
};

export default TimelinePagingHandler;
